import { Component, computed } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerComponent } from '@app/modules/core/components/color-picker/color-picker.component';
import { SliderComponent } from '@app/modules/core/components/slider/slider.component';
import { SwitchComponent } from '@app/modules/core/components/switch/switch.component';
import { FileUploadDirective, FileUploadEvent } from '@app/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetConfigFormTemplate } from '../widget-config-form-template';

@Component({
  selector: 'topo-image-widget-config-form',
  imports: [ReactiveFormsModule, TranslatePipe, FileUploadDirective, ColorPickerComponent, SliderComponent, SwitchComponent],
  templateUrl: './image-widget-config-form.component.html',
  styleUrl: './image-widget-config-form.component.scss'
})
export class ImageWidgetConfigFormComponent extends WidgetConfigFormTemplate {
  protected settingsGroup = computed(() => this.form?.get('imageCardSettings'));
  protected imageControl = computed(() => this.settingsGroup()?.get('imageDataUrl'));
  protected cardStyles = computed(() => this.settingsGroup()?.get('cardStyles'));
  protected showBackgroundControl = computed(() => this.settingsGroup()?.get('showBackground'));
  protected hasError = false;

  handleImageUpload(event: FileUploadEvent): void {
    this.imageControl()?.setValue(event.data);
    this.hasError = false;
  }

  handleError(err: Error): void {
    console.error(err);
    this.hasError = true;
  }

  formatOpacityValueForDisplay = (value: number) => `${Math.round(value * 100)} %`;
}
